<div class="hpanel margin-bottom-5">
  <div class="panel-heading hbuilt wig-c">
    {{ headerTitle }}
  </div>
  <div class="panel-body">
    <div class="row">
      <div class="col-lg-12">
        <ul class="profile-list">
          <ng-container *ngFor="let item of user | slice:0:3; let i=index">
            <app-common-profile-info [type]="'HASHTAG'">
              <ng-container headline1>Lakshmikandhan s</ng-container>
              <ng-container headline2>1 hour ago: 11,000 Views</ng-container>
              <ng-container btn>
                <button class="btn btn-primary btn-xs">
                  <!-- <ng-icon name="tablerPlus" aria-hidden="true"></ng-icon> -->
                   Follow</button>
              </ng-container>
            </app-common-profile-info>
          </ng-container>
        </ul>
        <!-- <p style="float: right;" *ngIf="user.length > 3">
          <u><a >...More</a></u>
        </p> -->

        
        <button class="gs-743-more-btn" type="button" *ngIf="user.length > 0">
          View more →
        </button>
      </div>
    </div>
  </div>
</div>
